module.exports = [
  {
    value: '1',
    label: 'Portfolio',
  },
  {
    value: '2',
    label: 'Quota',
  },
  {
    value: '3',
    label: 'Admission',
  },
  {
    value: '4',
    label: 'Direct Admission',
  },
  // {
  //   value: '41_2567',
  //   label: 'Direct Admission 1',
  // },
  // {
  //   value: '42_2567',
  //   label: 'Direct Admission 2',
  // },
];
